function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 5.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-5.066.842v1.374a.427.427 0 11-.856-.004c-.001-.92-.002-1.84 0-2.759a.427.427 0 01.768-.266c.065.086.09.184.089.292v1.363zM5.5 3.995a.583.583 0 00.585-.575.576.576 0 00-.572-.584.576.576 0 00-.585.571.583.583 0 00.572.588z",
  fill: "#B0B8CE"
});

function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    fill: "none"
  }, props), _ref);
}

export default SvgInfoIcon;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/infoIcon.svg
// module id = 1290
// module chunks = 10